// Generated by ts-to-zod
import { z } from 'zod';
import { labelSchema } from '../models/label.schema';

export const createLabelPayloadSchema = labelSchema.pick({
  name: true,
  color: true,
});
